<template>
  <div class="warp">
    <el-col :span="6" v-for="(item, index) in patientList" :key="index">
      <el-card class="box-card" style="margin: 0 10px 5px 0">
        <div class="card_warp">
          <div class="card_warp-top">
            <div class="card_warp-top-title">
              <div>
                <el-avatar
                  src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                ></el-avatar>
              </div>
              <div class="card_warp-top-name">
                {{ item.patient.patientName }}
              </div>
              <div class="card_warp-top-age">
                {{
                  item.patient.patientGenderName == 10901
                    ? "男"
                    : item.patient.patientGenderName == 10902
                    ? "女"
                    : ""
                }}
                {{ item.patient.patientAge }}岁
              </div>
            </div>
            <div class="card_warp-status">
              {{ PRESCRIPTION_STATUS_SIMPLE[item.recipe.status] }}
            </div>
          </div>
          <div class="card_warp-content">
            <div style="margin: 20px 0">
              创建时间：{{ item.recipe.gmtCreate }}
            </div>
            <div>手机号码：{{ item.patient.patientMobile }}</div>
          </div>
        </div>
        <div class="btn_flex">
          <div v-if="PRESCRIPTION_BUTTON[item.recipe.status]" class="handle">
            <el-button type="text" @click="headldetail(item)">{{
              PRESCRIPTION_BUTTON[item.recipe.status]
            }}</el-button>
          </div>
          <div>
            <el-button type="text" @click="patientsHandle(item)"
              >查看</el-button
            >
          </div>
        </div>
      </el-card>
    </el-col>
    <!-- 审核 -->
    <AuditDialog
      :auditDialogVisible="auditDialogVisible"
      :userItem="userItem"
      @changeShow="showAddOrUpdate"
      @refresh-item="refresh"
    ></AuditDialog>
  </div>
</template>
<script>
import {
  PRESCRIPTION_STATUS_SIMPLE,
  PRESCRIPTION_BUTTON,
} from "@/utils/constants";
import {
  prescriptionSign,
  prescriptionSignReview,
  prescriptionPdf,
  downloadPrescriptionPdf,
} from "@/api/doctor";
import AuditDialog from "@/components/auditDialog";

export default {
  name: "patientItem",
  components: {
    AuditDialog,
  },
  props: {
    patientList: Array,
  },
  data() {
    return {
      PRESCRIPTION_STATUS_SIMPLE,
      PRESCRIPTION_BUTTON,
      auditDialogVisible: false,
      userItem: { recipe:{ status:11800 } },
    };
  },
  methods: {
    async headldetail(item) {
      if (item.recipe.status == "11802") {
        //审核药师待审核(医生已签字)
        this.auditDialogVisible = true;
        this.userItem = item;
      } else if (item.recipe.status == "11804") {
        // 复核药师待复核(审核药师已签字)
        this.auditDialogVisible = true;
        this.userItem = item;
      } else {
        this.signature(item);
      }
    },
    // 监听 子组件弹窗关闭后触发，有子组件调用
    showAddOrUpdate(data) {
      if (data === "false") {
        this.auditDialogVisible = false;
      } else {
        this.auditDialogVisible = true;
      }
    },
    /*
     * 签字接口
     */
    async signature(item) {
      const params = {
        recipeId: item.recipe.id,
      };
      let res;
      if (item.recipe.status == "11803") {
        //审核药师待签字(审核药师已审核)
        res = await prescriptionSign(params);
      } else if (item.recipe.status == "11805") {
        // 复核药师待复核(审核药师已签字)
        res = await prescriptionSignReview(params);
      } else if (item.recipe.status == "11806") {
        // 待出报告(复核药师已签字)
        this.getPdf(item);
        return;
      } else if (item.recipe.status == "11807") {
        // 已出报告
        this.downloadPdf(item);
        return;
      }
      if (res.code == 1) {
        window.location.href = res.data;
        // this.$message({
        //   message: "设置成功",
        //   type: "success",
        // });
        this.refresh();
      } else {
        this.$message({
          message: "设置失败",
          type: "warning",
        });
      }
    },
     /*
     * 提示信息
     * */
     elementTips: function (type, message) {
        const $t = "";
        this.$message({
          showClose: true,
          message: message,
          type: type,
        });
      },
    /*
     *生成报告
     */
    async getPdf(item) {
      try {
        let data = {
          recipeId: item.recipe.id,
        };
        let res = await prescriptionPdf(data);
        if (res.code == 1) {
          this.elementTips("success", res.message);
          this.$emit("refresh-item", 1);
        } else {
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 下载报告
    async downloadPdf(item) {
      const params = {
        recipeId: item.recipe.id,
      };
      const res = await downloadPrescriptionPdf(params);

      // 创建隐藏<a>标签进行下载
      let filename = item.patient.patientName;
      var tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = res.data;
      tempLink.setAttribute("download", filename);
      tempLink.setAttribute("target", "_blank");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    },
    // 查看详情
    patientsHandle(item) {
      let query = {
        id: item.recipe.id,
        orderNo: item.recipe.orderNo,
      };
      this.$router.push({
        path: "/index/user/auditPrescription/prescriptionDetails",
        query,
      });
    },
    refresh() {
      this.$emit("refresh-item", 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.warp {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;

  .card_warp {
    .card_warp-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      .card_warp-top-title {
        display: flex;
        align-items: center;
        .card_warp-top-name {
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          margin: 0 15px;
        }
        .card_warp-top-age {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }
      }
      .card_warp-status {
        width: 82px;
        height: 24px;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        border-radius: 20px;
        background: #e94709;
      }
    }
    .card_warp-content {
      margin: 20px 0;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
    }
  }

  .btn_flex {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    display: flex;
    border-top: 1px solid #f0f0f0;
    div {
      width: 100%;
      text-align: center;
    }
    .handle {
      border-right: 1px solid #f0f0f0;
    }
    button {
      font-weight: bold;
    }
  }
}
</style>